/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Email_Change_HelpInputs */



/**
* | output |
* | --- |
* | "To change your email address, you must enter your password" |
*
* @param {Email_Change_HelpInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const email_change_help = /** @type {((inputs?: Email_Change_HelpInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Email_Change_HelpInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("To change your email address, you must enter your password")
	return /** @type {LocalizedString} */ ("Pour modifier votre adresse email, vous devez entrer votre mot de passe")
});